/* eslint-disable */
import { useState, useEffect, useRef, useMemo } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import JoditEditor from "jodit-react";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import { assetImages } from "constants";
import { ecosystemSlug } from "Config/Config";
import CurrencyOptions from "data/Prod/Currency.json";
import productStatusOptions from "data/Prod/ProductStatus.json";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import { reactSelectStyle } from "Config/Config";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import AfterSaveProductModal from "components/Common/Modal/AfterSaveProductModal";
import SaveProductForm from "components/Common/SaveProductForm/SaveProductForm";

const SaveMedicieBody = () => {
  const dateOfToday = new Date().toISOString().split("T")[0];
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const params = useParams();
  const history = useHistory();

  const formRef = useRef(null);

  const editor = useRef(null);

  const [productTypeList, setproductTypeList] = useState([]);

  const [companyInput, setCompanyInput] = useState("");
  const [companyList, setCompanyList] = useState([]);

  const [productTypeValue, setproductTypeValue] = useState(null);
  const [selectedProductTypeId, setselectedProductTypeId] = useState(null);
  const [companyValue, setcompanyValue] = useState(null);
  const [selectedCompanyId, setselectedCompanyId] = useState(null);
  const [name, setname] = useState("");
  const [summary, setsummary] = useState("");
  const [details, setdetails] = useState("");
  const [price, setprice] = useState("");
  const [currencyValue, setcurrencyValue] = useState(null);
  const [selectedCurrency, setselectedCurrency] = useState("");
  const [sku, setSku] = useState("");
  const [taxPercent, settaxPercent] = useState("");
  const [unit, setUnit] = useState("");
  const [weight, setweight] = useState("");
  const [length, setlength] = useState("");
  const [width, setwidth] = useState("");
  const [height, setheight] = useState("");
  const [startDate, setstartDate] = useState(dateOfToday || "");
  const [endDate, setendDate] = useState(dateOfToday || "");
  const [productStatusValue, setproductStatusValue] = useState(null);
  const [productStatus, setproductStatus] = useState("");
  const [uploadedPreviewImage, setUploadedPreviewImage] = useState("");
  const [uploadedImageId, setUploadedImageId] = useState(null); // use state for uploaded image id
  const [isUploading, setIsUploading] = useState(false);
  const [isProductFeatured, setIsProductFeatured] = useState(false);
  const [isServiceFeatured, setIsServiceFeatured] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [savedProductId, setSavedProductId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //** Hooks for validation */
  const [errors, setErrors] = useState({});

  const editorCustomConfig = {
    readonly: false,
    minHeight: 300,
    placeholder: "",
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1];
            const newFileName = `image-${timestamp}.${fileExtension}`;
            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;
              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  editorInstance.value = newContent;
                  setdetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  //** Validate function */
  const validateForm = () => {
    const newErrors = {};

    if (selectedProductTypeId === null) {
      newErrors.type = t(
        "Product type is required. Please select a category for your product."
      );
    }

    if (selectedCompanyId === null) {
      newErrors.company = t(
        "Company/Store is required. Please associate this product with a company."
      );
    }

    if (!name.trim()) {
      newErrors.name = t(
        "Product name is required. Please provide a name for your product."
      );
    }

    if (!sku.trim()) {
      newErrors.sku = t(
        "SKU is required. Please enter a unique Stock Keeping Unit."
      );
    }

    if (price === "" || price < 0) {
      newErrors.price = t(
        "A valid price is required. Please enter a price of 0 or more."
      );
    }

    if (taxPercent === "" || taxPercent < 0) {
      newErrors.vat = t(
        "VAT is required. Please enter a valid VAT percentage."
      );
    }

    if (unit === "" || unit < 0) {
      newErrors.unit = t(
        "Stock quantity is required. Please enter the available units."
      );
    }

    if (uploadedImageId === null) {
      newErrors.image = t(
        "A product image is required. Please upload an image."
      );
    }

    // Date comparison validation
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start.getTime() > end.getTime()) {
        newErrors.dateRange = t("End date cannot be earlier than start date.");
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //get all product types
  const getAllProductType = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_PRODUCT_TYPE +
        `?ecosystemslug=${ecosystemSlug}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setproductTypeList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all contacts
  const getAllCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${companyInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for open image imput
  // const openImageFileInput = () => {
  //   imageFileInputRef.current.click();
  // };

  //function for image upload
  const imageUploadHandler = async (imageFIles) => {
    setErrors((prev) => ({ ...prev, image: "" }));

    const file = imageFIles[0];
    setIsUploading(true);
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadSingleFile(requestUrl, file);

      if (response.status) {
        setIsUploading(false);
        setUploadedPreviewImage(response.data.path);
        setUploadedImageId(response.data._id);
        resetImageFile();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // function for clear file value
  const resetImageFile = () => {
    const file = document.getElementById("uploadedImageFile");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //function for select product type
  const productTypeSelectionHandler = (val) => {
    if (errors.type) {
      setErrors((prev) => ({ ...prev, type: "" }));
    }
    if (val) {
      setproductTypeValue(val);
      setselectedProductTypeId(val.value);
    } else {
      setproductTypeValue(null);
      setselectedProductTypeId(null);
    }
  };

  //function for select company
  const companySelectionHandler = (val) => {
    if (errors.company) {
      setErrors((prev) => ({ ...prev, company: "" }));
    }
    if (val) {
      setcompanyValue(val);
      setselectedCompanyId(val.value);
    } else {
      setcompanyValue(null);
      setselectedCompanyId(null);
      setCompanyInput("");
      setCompanyList([]);
    }
  };

  //function for select currency
  const currencySelectionHandler = (val) => {
    if (val) {
      setcurrencyValue(val);
      setselectedCurrency(val.value);
    } else {
      setcurrencyValue(null);
      setselectedCurrency("");
    }
  };

  //function for select product status
  const productStatusSelectionHandler = (val) => {
    if (val) {
      setproductStatusValue(val);
      setproductStatus(val.value);
    } else {
      setproductStatusValue(null);
      setproductStatus("");
    }
  };

  //function for get product details
  const getProductDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PRODUCT_DETAILS +
        `/${params.id}?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const data = response.data;

        if (data.producttypevalue) {
          productTypeSelectionHandler(data.producttypevalue);
        }

        if (data.companyvalue) {
          companySelectionHandler(data.companyvalue);
        }

        if (data.currencyValue) {
          currencySelectionHandler(data.currencyValue);
        }

        if (data.productstatusvalue) {
          productStatusSelectionHandler(data.productstatusvalue);
        }

        setname(data.name);
        setSku(data.sku);
        setsummary(data.summary);
        setdetails(data.description);
        setprice(data.price);
        setUnit(data.unit);
        setweight(data.weight);
        setlength(data.length);
        setwidth(data.width);
        setheight(data.height);
        setstartDate(data.startdate);
        setendDate(data.enddate);
        setUploadedImageId(data.productimage);
        setUploadedPreviewImage(data.productimagepath);
        settaxPercent(data.taxpercent);
        setIsProductFeatured(data.isproductfeatured);
        setIsServiceFeatured(data.isservicefeatured);
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for save product info
  const saveProductInfoHandler = async () => {
    if (!validateForm()) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }
    try {
      setIsSaving(true);

      let productData = {
        companyid: selectedCompanyId,
        producttypeid: selectedProductTypeId,
        productimage: uploadedImageId,
        name,
        summary,
        description: details,
        price,
        unit,
        currency: selectedCurrency,
        sku,
        taxpercent: taxPercent,
        stock: unit,
        weight,
        length,
        width,
        height,
        startdate: startDate,
        enddate: endDate,
        productstatus: productStatus,
        isproductfeatured: isProductFeatured,
        isservice: isServiceFeatured,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestUrl += url.API_UPDATE_PRODUCT + `/${params.id}?token=${token}`;
        response = await putData(requestUrl, productData);
      } else {
        productData.gallery = [uploadedImageId];
        requestUrl += url.API_ADD_PRODUCT + `?token=${token}`;
        response = await postData(requestUrl, productData);
      }

      setIsSaving(false);

      console.log("response of save product------>", response);

      if (response.status) {
        setSavedProductId(response.data._id);
        setMessageType("success");

        setTimeout(() => {
          const bootstrapModal = new bootstrap.Modal(
            document.getElementById("saveProductinfo")
          );
          bootstrapModal.show();
        }, 1500);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for close afterSaveEventModal
  const afterSaveModalClose = (pageName = "") => {
    if (pageName == "details") {
      history.push(
        `/admin/clinicalmanagement/medicines/save/${savedProductId}`
      );
    } else {
      history.push("/admin/clinicalmanagement/medicines");
    }
  };

  useEffect(() => {
    if (params.id) {
      getProductDetails();
    }
  }, [params.id]);

  useEffect(() => {
    if (companyInput.length > 1) {
      getAllCompanyList();
    }
  }, [companyInput]);

  useEffect(() => {
    getAllProductType();
    currencySelectionHandler(CurrencyOptions[0]);
    productStatusSelectionHandler(productStatusOptions[0]);
  }, []);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const customTypeStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.type ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.type ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  const customCompanyStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.company ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.company ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div id="content_wrapper">
      <section className="crm-wrapper bg-white pb-5">
        <TabsHeader
          commonHeaderObject={commonHeaderLinkLists(t)}
          activeOption="Doctor Medicines"
        />
        <div className="container-fluid px-lg-5">
          <div className="container-fluid d-flex align-items-center gap-2 gap-sm-4 px-lg-3 my-3">
            <Link
              to="/admin/clinicalmanagement/medicines"
              className="back-btn d-flex flex-shrink-0 align-items-center justify-content-center body-bg text-gray rounded-circle"
            >
              <span className="d-block material-symbols-outlined">
                arrow_back
              </span>
            </Link>
          </div>
          <SaveProductForm
            productTypeList={productTypeList}
            companyList={companyList}
            productTypeValue={productTypeValue}
            companyValue={companyValue}
            productTypeSelectionHandler={productTypeSelectionHandler}
            companySelectionHandler={companySelectionHandler}
            setCompanyInput={setCompanyInput}
            name={name}
            setname={setname}
            sku={sku}
            setSku={setSku}
            summary={summary}
            setsummary={setsummary}
            details={details}
            setdetails={setdetails}
            price={price}
            setprice={setprice}
            currencyValue={currencyValue}
            currencySelectionHandler={currencySelectionHandler}
            taxPercent={taxPercent}
            settaxPercent={settaxPercent}
            unit={unit}
            setUnit={setUnit}
            weight={weight}
            setweight={setweight}
            length={length}
            setlength={setlength}
            width={width}
            setwidth={setwidth}
            height={height}
            setheight={setheight}
            startDate={startDate}
            setstartDate={setstartDate}
            endDate={endDate}
            setendDate={setendDate}
            productStatusValue={productStatusValue}
            productStatusSelectionHandler={productStatusSelectionHandler}
            imageUploadHandler={imageUploadHandler}
            uploadedPreviewImage={uploadedPreviewImage}
            setUploadedPreviewImage={setUploadedPreviewImage}
            setUploadedImageId={setUploadedImageId}
            isUploading={isUploading}
            isServiceFeatured={isServiceFeatured}
            setIsServiceFeatured={setIsServiceFeatured}
            isProductFeatured={isProductFeatured}
            setIsProductFeatured={setIsProductFeatured}
            isSaving={isSaving}
            saveProductInfoHandler={saveProductInfoHandler}
            customTypeStyles={customTypeStyles}
            customCompanyStyles={customCompanyStyles}
            errors={errors}
            setErrors={setErrors}
          />
        </div>

        <AfterSaveProductModal afterSaveModalClose={afterSaveModalClose} />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </section>
    </div>
  );
};

export default SaveMedicieBody;
